const VERSION = '2.0.22a'
export default VERSION
